var map = {
	"./battles.png": "79a3",
	"./blackjack.png": "6bb0",
	"./cases.png": "0aa1",
	"./crash.png": "3acd",
	"./duels.png": "050d",
	"./mines.png": "0814",
	"./roll.png": "8dea",
	"./slots.png": "bf2f",
	"./towers.png": "9032",
	"./upgrader.png": "704b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9f2";